/**
 * A resource name targets an Instruqt resource, examples are:
 * - team:<team_id>
 * - team:<team_id>:track:<track_id>
 * The frontend can also handle resource name synonyms, these resource names contain slugs instead of IDs. This is
 * necessary because our routing relies on slugs not on IDs. So for example:
 * - team:<team_slug>
 */
export interface ResourceName {
  getTeamIDOrSlug(): string;

  toString(): string;
}

export class TeamResourceName {
  static ANY = '__ANY__';
  static INVALID = '__invalid__';

  private readonly teamID?: string;
  private readonly teamSlug?: string;

  constructor(teamID?: string, teamSlug?: string) {
    if (!teamID && !teamSlug) {
      throw new TypeError('a TeamResourceName should contain either an ID or a slug');
    }

    this.teamID = teamID;
    this.teamSlug = teamSlug;
  }

  getTeamIDOrSlug() {
    return this.teamID || this.teamSlug || TeamResourceName.INVALID;
  }

  toString() {
    return `team:${this.teamID || this.teamSlug || TeamResourceName.INVALID}`;
  }

  static any() {
    return new TeamResourceName(TeamResourceName.ANY);
  }

  static byID(id: string) {
    return new TeamResourceName(id);
  }

  static bySlug(slug: string) {
    return new TeamResourceName(undefined, slug);
  }
}
